<template>
  <div class="page">
    <div class="page-title">Nodes</div>
    <div class="page-content">
      <div class="breadcrumbs">
        <span v-if="node">
          <router-link class="link" to="/nodes">Locations</router-link>
          <router-link
            v-if="location"
            class="link"
            :to="`/nodes/${location.id}`"
            >{{ location.title }}</router-link
          >
          <router-link
            v-if="$route.params.nodeType"
            class="link"
            :to="`/nodes/${location.id}/${$route.params.nodeType}`"
            >{{
              $consts.NODE_LABELS_FOR_PATH_TYPE[$route.params.nodeType]
            }}</router-link
          >
          {{ node.title }}
        </span>
        <span v-else-if="$route.params.nodeType">
          <router-link class="link" to="/nodes">Locations</router-link>
          <router-link
            v-if="location"
            class="link"
            :to="`/nodes/${location.id}`"
            >{{ location.title }}</router-link
          >
          {{ $consts.NODE_LABELS_FOR_PATH_TYPE[$route.params.nodeType] }}
        </span>
        <span v-else-if="location">
          <router-link class="link" to="/nodes">Locations</router-link>
          {{ location.title }}
        </span>
        <span v-else>Locations</span>
      </div>
      <div v-if="!$route.params.locationId">
        <h4 class="text-center">Where is the node you wish to view?</h4>
        <LocationSelect
          @select="(location) => $router.push(`/nodes/${location.id}`)"
        ></LocationSelect>
      </div>
      <div v-if="$route.params.locationId && !$route.params.nodeType">
        <h4 class="text-center mb-2">What type of node do you wish to view?</h4>
        <NodeTypePicker
          @select="
            (nodeType) =>
              $router.push(`/nodes/${$route.params.locationId}/${nodeType}`)
          "
        ></NodeTypePicker>
      </div>
      <Nodes
        v-if="$route.params.nodeType && !$route.params.nodeId"
        :location="location"
        :isLoading="isLoading"
      ></Nodes>
      <Node
        v-if="$route.params.nodeId"
        :location="location"
        :node="node"
        :isLoading="isLoading"
      ></Node>
    </div>
  </div>
</template>

<script>
import LocationSelect from "@/components/LocationSelect";
import NodeTypePicker from "@/components/NodeTypePicker";
import Nodes from "@/components/Nodes";
import Node from "@/components/Node";

export default {
  name: "nodes",
  components: {
    LocationSelect,
    NodeTypePicker,
    Nodes,
    Node,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {},
  computed: {
    nodeType() {
      return this.$route.params.nodeType;
    },
    location() {
      if (!this.$route.params.locationId) return null;

      var list = this.$store.state.locations.list;
      return list.find((location) => {
        return this.$route.params.locationId == location.id;
      });
    },
    node() {
      if (!this.location) return null;

      var nodeType = this.$route.params.nodeType;
      var nodeId = this.$route.params.nodeId;
      if (!nodeType && !nodeId) return null;

      var nodeTypeNum = this.$consts.NODE_TYPE_STR_TO_INT[nodeType];
      return this.location.nodes[nodeTypeNum].find((node) => {
        return node.id == nodeId && node.node.type === nodeTypeNum;
      });
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch("loadLocations");

    if (this.location && this.$route.params.nodeType) {
      var nodeTypeNum = this.$consts.NODE_TYPE_STR_TO_INT[
        this.$route.params.nodeType
      ];
      await this.$store.dispatch("loadNodes", {
        location: this.location,
        nodeType: nodeTypeNum,
      });
    }
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  .link {
    &:after {
      content: " • ";
    }
  }
}
</style>
